import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const ContainerFluid = (props) => {
    return (React.createElement(ContainerFluidStyled, { className: `container-fluid ${props.className}` }, props.children));
};
export default ContainerFluid;
const ContainerFluidStyled = styled.div `
  &.container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: ${THEME.GRID_SPACING}px;
    padding-right: ${THEME.GRID_SPACING}px;
  }
  &.container-fluid:before,
  &.container-fluid:after {
    content: ' ';
    display: table;
  }
  &.container-fluid:after {
    clear: both;
  }
`;
//# sourceMappingURL=ContainerFluid.js.map